import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
// import { UpdateFaqForm } from "@/components/faqs/update-faq-form";
import { lazy } from "react";

// import { RichTextDisplay } from "@/components/base/rich-text-editor/display";
import { useViewerHasPermission } from "@/auth/shared";
import {
  Disclosure,
  DisclosureGroup,
  DisclosureHeader,
  DisclosurePanel,
} from "@/components/base/disclosure";
import { title } from "@/components/base/primitives";
// import { CreateFaqForm } from "@/components/faqs/create-faq-form";
import { DeleteFaqForm } from "@/components/faqs/delete-faq-form";
import { ReorderFaqsForm } from "@/components/faqs/reorder-faqs-form";
import { useTRPC } from "@/integrations/trpc/react";
import { DefaultLayout } from "@/layouts/default";

const CreateFaqForm = lazy(async () => {
  const mod = await import("@/components/faqs/create-faq-form");

  return {
    default: mod.CreateFaqForm,
  };
});

const UpdateFaqForm = lazy(async () => {
  const mod = await import("@/components/faqs/update-faq-form");

  return {
    default: mod.UpdateFaqForm,
  };
});

const RichTextDisplay = lazy(async () => {
  const mod = await import("@/components/base/rich-text-editor/display");

  return {
    default: mod.RichTextDisplay,
  };
});

export const Route = createFileRoute("/tournaments/faqs")({
  ssr: "data-only",
  loader: async ({ context: { queryClient, trpc } }) => {
    return await queryClient.ensureQueryData(
      trpc.faqs.list.queryOptions({ key: "tournaments" }),
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const trpc = useTRPC();

  const { data: faqs } = useSuspenseQuery(
    trpc.faqs.list.queryOptions({ key: "tournaments" }),
  );

  const canCreate = useViewerHasPermission({
    faqs: ["create"],
  });

  const canUpdate = useViewerHasPermission({
    faqs: ["update"],
  });

  return (
    <DefaultLayout>
      <div className="mx-auto max-w-4xl px-4 py-8">
        <div className="mb-12 flex items-center justify-between">
          <h1 className={title()}>Tournament FAQs</h1>

          <div className="flex flex-row gap-2">
            {canUpdate && <ReorderFaqsForm groupKey="tournaments" />}
            {canCreate && <CreateFaqForm groupKey="tournaments" />}
          </div>
        </div>

        {faqs && faqs.length === 0 && <p>No FAQs yet...</p>}

        {Boolean(faqs?.length) && (
          <DisclosureGroup>
            {faqs.map(({ id, question, answer }) => (
              <Disclosure key={id}>
                <DisclosureHeader
                  color="alt"
                  contentClassName="flex-1 flex flex-row justify-between items-center"
                >
                  <span>{question}</span>

                  {canUpdate && (
                    <span className="flex flex-row items-center space-x-2">
                      <UpdateFaqForm id={id} groupKey="tournaments" />
                      <DeleteFaqForm id={id} question={question} />
                    </span>
                  )}
                </DisclosureHeader>
                <DisclosurePanel color="alt">
                  <RichTextDisplay
                    name="faq-answer"
                    content={
                      typeof answer === "string" ? JSON.parse(answer) : answer
                    }
                  />
                </DisclosurePanel>
              </Disclosure>
            ))}
          </DisclosureGroup>
        )}
      </div>
    </DefaultLayout>
  );
}
